import axios from './interceptors'
import { md5 } from './md5'
import request from './request'
import { setItem, getItem } from './localStorage'
import { getCurrentSelectedMode, getCodes } from './commonUtil'
import { getNowTime, parseNowTime } from './dateUtil'

export {
  axios,
  md5,
  request,
  setItem,
  getItem,
  getCurrentSelectedMode,
  getCodes,
  getNowTime,
  parseNowTime
}



// WEBPACK FOOTER //
// ./src/tools/index.js